/** @jsxImportSource @emotion/react */
import { Box, Skeleton, css, useTheme, Typography, Alert } from '@mui/material'

interface DemoPageLoadingProps {
  isError?: boolean
  errorMessage?: Error['message'] | string
}

export function DemoPageLoading({ isError, errorMessage }: DemoPageLoadingProps) {
  const theme = useTheme()

  if (isError) {
    return (
      <Box
        css={css`
          background-color: #fff;
          padding: ${theme.spacing(4)} 0;
          margin: ${theme.spacing(6)} 0;
        `}
      >
        <Alert severity="error">{errorMessage ?? 'Something went wrong.'}</Alert>
      </Box>
    )
  }

  return (
    <Box
      css={css`
        background-color: #fff;
        padding: ${theme.spacing(4)} 0;
        margin: ${theme.spacing(6)} 0;
      `}
    >
      {/* Title */}
      <Typography component="h1" variant="h3" sx={{ mb: 2, fontWeight: 600 }}>
        <Skeleton width="60%" />
      </Typography>

      {/* Video skeleton */}
      <Skeleton
        variant="rectangular"
        sx={{
          width: '100%',
          height: '50vh',
          borderRadius: '8px',
          mb: 3,
        }}
      />

      {/* Summary skeleton */}
      <Box>
        <Skeleton width="90%" />
        <Skeleton width="95%" />
        <Skeleton width="80%" />
        <Skeleton width="92%" />
        <Skeleton width="70%" />
      </Box>
    </Box>
  )
}
